import React, { useRef } from 'react';
import useFocusTrap from '../Hooks/useFocusTrap';
import useClickOutside from './UseClickOutside';

const ConfirmationModel = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmation delete?",
  message = "Are you sure you want to delete this item?",
  confirmText = "Delete",
  cancelText = "Cancel",
}) => {
  const modalRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const confirmButtonRef = useRef(null);

  // Close when clicking outside
  useClickOutside(modalRef, () => {
    if (isOpen) onClose();
  });

  // Use the centralized focus trap hook
  useFocusTrap(isOpen, onClose, cancelButtonRef, confirmButtonRef, confirmButtonRef);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-sm transition-opacity duration-300 p-4"
      aria-modal="true"
      role="dialog"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        ref={modalRef}
        className="bg-[#131418] rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg relative transform transition-transform duration-300 border-2 border-[#2d2e32] overflow-hidden shadow-lg"
        style={{
          background: 'linear-gradient(145deg, #191a20 0%, #131418 100%)',
          boxShadow:
            '0 0 15px rgba(255, 255, 255, 0.07), inset 0 0 30px rgba(255, 255, 255, 0.03)',
        }}
      >
        <div className="p-3 sm:p-4">
          {/* Modal Title */}
          <h1 id="modal-title" className="font-bold text-lg text-white">
            {title}
          </h1>

          {/* Modal Subtitle */}
          <h2
            id="modal-description"
            className="text-xs sm:text-sm text-white text-opacity-70 font-semibold mb-1"
          >
            {message}
          </h2>
        </div>

        {/* Divider - Full width with no margins */}
        <div className="h-px w-full bg-[#2d2e32]"></div>

        {/* Button Container */}
        <div className="p-3 sm:p-4">
          <div className="flex justify-end space-x-3">
            {/* Cancel Button */}
            <button
              ref={cancelButtonRef}
              className="bg-[#2D2E32] text-white text-sm font-semibold py-1.5 px-3 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-40 focus:ring-offset-1 focus:ring-offset-[#131418] border border-white border-opacity-5 transition duration-200 hover:bg-[#3D3E42]"
              onClick={onClose}
            >
              {cancelText}
            </button>

            {/* Confirm Button */}
            <button
              ref={confirmButtonRef}
              className="bg-[#ee2b2a] text-white text-sm font-semibold py-1.5 px-3 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-[#ee2b2a] focus:ring-offset-1 focus:ring-offset-[#131418] transition duration-200 hover:bg-[#ff3b3a]"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModel;
